import React, { useEffect, useState, useRef } from "react";
import classes from "./Payables.module.css";
import HeaderNav from '../../Accoungting/HeaderNav/HeaderNav';
import Footer from "../../Accoungting/Footer/Footer";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../../Assets/searchicon.png";
import filter from "../../../Assets/filter.png";
import { Pen, Trash2, Printer } from "lucide-react";
import axios from "axios";
import { BASE_URL } from '../../../Components/Styles/API/API';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Button, Modal, Form, Spinner, Tab, Tabs, Row, Col, Popover, Container } from 'react-bootstrap';
import { FaTrash, FaPlus } from "react-icons/fa";

import Select from "react-select";
import crop from "../../../Assets/repoort.png";
import verified from "../../../Assets/verified.svg";
import Swal from "sweetalert2";
import CurrencyInput from "react-currency-input-field";
// import PayableEntryModal from "../../Accounting/Payments/CashReciept/PayableEntryModal";
import classesStyles from "../../Accounting/Manage Suppliers Payables/Supplier.module.css";




const PayablesEntries = () => {
  // Add these states after the existing state declarations around line 60
const [showSupplierModal, setShowSupplierModal] = useState(false);
const [rows, setRows] = useState([{ bankName: "", accName: "", accNo: "" }]);
const [supplierFullName, setSupplierFullName] = useState("");
const [supplierEmail, setSupplierEmail] = useState("");
const [supplierPhone, setSupplierPhone] = useState("");
const [supplierAddress, setSupplierAddress] = useState("");
const [supplierLoading, setSupplierLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const handleShow1 = () => setShow1(true);
  const handleShow2 = () => setShow2(true);
  const handleClose1 = () => setShow1(false);
  const [attachment, setAttachment] = useState(null);
  const handleClose2 = () => setShow2(false);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRadio, setSelectedRadio] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [paymentDate, setPaymentDate] = useState("");
  const [description, setDescription] = useState("");
  const [accountExpenses, setAccountExpenses] = useState("");
  const [accountCode, setAccountCode] = useState("");
  const [accountPayables, setAccountPayables] = useState("");
  // const [amount, setAmount] = useState("");
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [bankOptions, setBankOptions] = useState([]);
  const [bankOptions1, setBankOptions1] = useState([]);
  const [bankOptions2, setBankOptions2] = useState([]);
  const [supplierOptions2, setSupplierOptions2] = useState([]);
  const [paymentMode, setPaymentMode] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [selectedBank, setSelectedBank] = useState(null);
  const [selectedPayableType, setSelectedPayableType] = useState(null);
  const [selectedBank2, setSelectedBank2] = useState(null);
  const [selectedSupplier2, setSelectedSupplier2] = useState(null);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState(null);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [invoiceOptions, setInvoiceOptions] = useState([]);
  const [addpaymenntLoad, setAddPaymenntLoad] = useState(false);
  const [addpaymenntLoad2, setAddPaymenntLoad2] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [totalEntries, setTotalEntries] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [bearer, setBearer] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingPayee, setIsLoadingPayee] = useState(false);
  const [currLoading, setCurrLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [tableData1, setTableData1] = useState([]);
  const [user, setUser] = useState('');
  const [userID, setUserID] = useState('');
  const [currency, setCurrency] = useState([]);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedBankAc, setSelectedBankAc] = useState('');
  const [selectedBankName, setSelectedBankName] = useState('');
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [currentMonth, setCurrentMonth] = useState('');
  const [selectOptions1, setSelectOptions1] = useState([]);
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [updateId, setUpdateId] = useState(null);
  const [updatePaymentLoading, setUpdatePaymentLoading] = useState(false);
  // const [showSupplierModal, setShowSupplierModal] = useState(false);

  // Form Fields (Prefixed with 'edit')
  const [editDescription, setEditDescription] = useState("");
  const [editAmount, setEditAmount] = useState("");
  const [editDate, setEditDate] = useState(""); // For Transaction Date
  const [editPayableType, setEditPayableType] = useState(null);
  const [editSelectedSupplier, setEditSelectedSupplier] = useState(null);
  const [editCurrency, setEditCurrency] = useState(null);
const [searchTerm, setSearchTerm] = useState("");

  // Account Breakdown Fields (Prefixed with 'edit')
  const [editAccountExpenses, setEditAccountExpenses] = useState("");
  const [editAccountPayables, setEditAccountPayables] = useState("");
  const [editAccountCode, setEditAccountCode] = useState("");
  const [editSelectedBank, setEditSelectedBank] = useState(null);  // For Expense/Bank Select
  const [editSelectedBank2, setEditSelectedBank2] = useState(null); // For Payable Select
  const [editAttachment, setEditAttachment] = useState(null);
  const [editExistingAttachment, setEditExistingAttachment] = useState(null);
   // Stores the URL string
   const [amount, setAmount] = useState(0);
   const [tax, setTax] = useState([]);
   const [taxAmount, setTaxAmount] = useState(0);
   const [totalAmount, setTotalAmount] = useState(0);
   const [taxOptions, setTaxOptions] = useState([]);
  //  const [tax, setTax] = useState([]);
   const [taxFlag, setTaxFlag] = useState("0,0"); 
   const [taxDescription, setTaxDescription] = useState("");
   const [vatFlag, setVatFlag] = useState(0);
    const [whtFlag, setWhtFlag] = useState(0);





  const handleEditClick = (item) => {
    console.log(item)
    setUpdateId(item.id);
    setEditPayableType(item?.payable_type)

    // 1. Basic Strings
    setEditDescription(item.description || "");
    setEditAmount(item.amount || ""); // This sets the Amount for both the top and the table
    setEditDate(item.transaction_date || "");

    // 2. Supplier
    if (item.supplier) {
      setEditSelectedSupplier({ value: item.supplier.id, label: item.supplier.name });
    } else {
      setEditSelectedSupplier(null);
    }

    // 3. Currency
    if (item.currency) {
      const foundCurr = currencyOptions.find(c => c.value == item.currency);
      setEditCurrency(foundCurr || { value: item.currency, label: item.currency });
    }

    // 4. Payable Type
    // if (item.payable_type) {
    //     setEditPayableType({ value: item.payable_type, label: "Type " + item.payable_type }); 
    // } else {
    //     setEditPayableType(null);
    // }

    // 5. Account Payables (The Top Field - CREDIT SIDE)
    // Uses 'credit_account' from your data
    if (item.credit_account) {
      setEditAccountPayables(item.credit_account.gl_name);

      // Populate the Select state for Account Payables
      setEditSelectedBank2({
        value: item.credit_account.id,
        label: item.credit_account.gl_name,
        gl_code: item.credit_account.gl_code
      });
    } else {
      setEditAccountPayables("");
      setEditSelectedBank2(null);
    }

    // 6. Account Breakdown (The Table - DEBIT SIDE)
    // ✅ Uses 'invoice_detail' as requested
    if (item.invoice_detail && item.invoice_detail.length > 0) {
      const detail = item.invoice_detail[0]; // Get the first item in the array

      // Ensure the nested 'glname' object exists
      if (detail.glname) {
        // Set Account Name (Text Input Version)
        setEditAccountExpenses(detail.glname.gl_name);

        // Set Account Code
        setEditAccountCode(detail.glname.gl_code);

        // Set Account Name (Select Dropdown Version)
        setEditSelectedBank({
          value: detail.glname.id,      // e.g. 49
          label: detail.glname.gl_name, // e.g. "BUILDING REPAIRS & MAINTENANCE"
          gl_code: detail.glname.gl_code // e.g. "55008"
        });
      }
    } else {
      // Clear these if no detail exists
      setEditAccountExpenses("");
      setEditAccountCode("");
      setEditSelectedBank(null);
    }

    // 7. Handle Attachment
    setEditAttachment(null);
    if (item.attached_document) {
      setEditExistingAttachment(item.attached_document);
    } else {
      setEditExistingAttachment(null);
    }

    setShowUpdateModal(true);
  };

  const readData = async () => {
    try {
      const value = localStorage.getItem('userToken');
      const value1 = localStorage.getItem('tobi');
      const valueID = localStorage.getItem('tobiID');
      const current = localStorage.getItem('currentMonth');
      console.log(value);

      if (value !== null && value.trim() !== '') {
        setBearer(value);
        console.log(bearer)
      } else {
        navigate('/login');
        return;
      }
      if (value1 !== null) {
        setUser(value1);
      }
      if (valueID !== null) {
        setUserID(valueID);
      }
      if (current !== null) {
        console.log(current)
        const date = new Date(current);  // Assume current is in a parsable date format

        setCurrentMonth(date);
        const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
        const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        // Set the min and max date for the date input

        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');  // Add leading zero
          const day = String(date.getDate()).padStart(2, '0');         // Add leading zero
          return `${year}-${month}-${day}`;
        };

        setMinDate(formatDate(startOfMonth));
        setMaxDate(formatDate(endOfMonth));

        console.log(formatDate(startOfMonth), formatDate(endOfMonth));

      }

    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  // Handlers that persist changes 
  const handleDateChange = (e) => {
    const value = e.target.value;
    setSelectedDate(value);
  };

  const handleBankChangeNew12 = (option) => {
    setSelectedPayableType(option);
  };

  const isSupplierBasedPayable = (typeValue) => {
  return typeValue === "1" || typeValue === "5";
};

const handleBankChangeNew = (selectedOption) => {
  setSelectedPayableType(selectedOption);
  setSelectedSupplier2(null);
  setAccountExpenses("");
  setAccountPayables("");
  setAccountCode("");

  if (!selectedOption) return;

  // 🔁 Map Fixed Asset (5) → Supplier (1)
  const apiTypeId = selectedOption.value === "5" ? "1" : selectedOption.value;

  // Only supplier-based types should fetch suppliers
  if (apiTypeId === "1") {
    fetchPayablessss(apiTypeId);
  } else {
    setSupplierOptions2([]);
  }
};




  const handleSupplierChange = (option) => {
    if (option) {
      setSelectedSupplier2(option);
      setAccountExpenses(option?.expense || "");
      setAccountPayables(option?.payable || "");
    } else {
      setSelectedSupplier2(null);
      setAccountExpenses("");
      setAccountPayables("");
    }
  };

  const handleAmountChange = (value) => {
    setAmount(value);
  };

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };




  const printRef = useRef();
  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };


  const handleRadioChange = (e) => {
    const value = e.target.value;
    setSelectedRadio(value);

    if (value === "general") {
      setSelectedCustomer(null);
    }
  };

  const handleDateChangeNew = (event) => {
    setSelectedDate(event.target.value);
  };


  const handleBankChange = (selectedOption) => {
    setSelectedBank(selectedOption.value);
    setSelectedBankName(selectedOption.label);
    setSelectedBankAc(selectedOption.acNo);
  };


  // useEffect(() => {
  //   const fetchInvoices = async () => {
  //     try {
  //       const token = localStorage.getItem("authToken");
  //       const res = await axios.get(`${BASE_URL}/v1/payments-made`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //             Accept: "application/json",
  //           },
  //         }
  //       );
  //       if (res.data && res.data.status && Array.isArray(res.data.data)) {
  //         setInvoices(res.data.data);
  //       }
  //     } catch (err) {
  //       // Optionally handle error
  //       setInvoices([]);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchInvoices();
  // }, []);

  const handlePrevPage = () => {
    setCurrentPage(Math.max(currentPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage(Math.min(currentPage + 1, totalPages));
  };

  // const totalEntries = filteredData.length;
  const startIndexx = (currentPage - 1) * entriesPerPage + 1;
  const endIndexx = Math.min(startIndexx + entriesPerPage - 1, totalEntries);


  const handleCheckboxChange = (row) => {
    const selectedIndex = selectedRows.findIndex(item => item.id === row.id);
    let updatedSelectedRows = [];

    if (selectedIndex === -1) {
      updatedSelectedRows = [...selectedRows, row];
    } else {
      updatedSelectedRows = selectedRows.filter(item => item.id !== row.id);
    }

    setSelectedRows(updatedSelectedRows);
    setSelectAll(updatedSelectedRows.length === tableData.length);
  };

  const isSelected = (row) => {
    return selectedRows.some(item => item.id === row.id);
  };

  const handleSelectAllChange = (event) => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);
    setSelectedRows(isChecked ? [...tableData] : []);
    // console.log(isChecked ? [...tableData] : []);
  };

  const fetchInvoices = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const res = await axios.get(`${BASE_URL}/v1/payments-made`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      if (res.data && res.data.status && Array.isArray(res.data.data)) {
        setInvoices(res.data.data);
      }
    } catch (err) {
      setInvoices([]);
    } finally {
      setLoading(false);
    }
  };

  // load invoices on mount
  useEffect(() => {
    fetchInvoices();
  }, []);

  //   const fetchExpenses = async () => {
  //   setIsLoading(true);
  //   try {
  //     const response = await axios.get(`${BASE_URL}/fetch-all-payments?page=${currentPage}`, { headers });

  //     const results = response.data?.data?.data;
  //     const resultx = response.data?.data?.total;
  //     setTotalEntries(resultx);
  //     setTableData(results);
  //     // console.log(results, "accounts");
  //     const total = response.data?.data?.last_page || 1;
  //     setTotalPages(total);
  //   } catch (error) {
  //     const errorStatus = error.response?.data?.message;
  //     console.log(errorStatus);
  //     setTableData([]);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const fetchPending = async () => {
    setIsLoadingPayee(true);
    try {
      const response = await axios.get(`${BASE_URL}/fetch-pending-payables`, { headers });
      const results = response.data?.data;

      setTableData(results);
      console.log("response:", response);

    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            console.log(errorMessage);
          }
        }
        setTableData([]);
      }
    } finally {
      setIsLoadingPayee(false);
    }
  };

  const fetchDebit = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/account/bank-accounts`, { headers });
      const debitAcct = response.data?.data;

      const options1 = debitAcct.map((item) => ({
        label: item.gl_name,
        value: item.id,
        acNo: item.gl_code,
      }));

      setTableData1(debitAcct);
      setSelectOptions1(options1);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setTableData1([]);
    } finally {
      setIsLoading(false);
    }
  };



  useEffect(() => {
    if (bearer) {
      fetchPending();
      fetchDebit();
    }
  }, [bearer]);

  const fetchCurrency = async () => {
    setCurrLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/fetch-all-currencies`, { headers });
      const results = response.data?.data;
      // console.log(results, "currencis")
      const options = results.map((item) => ({
        label: item.name || item.code,
        value: item.id,
        symbol: item.symbol
      }));
      setCurrency(results);
      setCurrencyOptions(options);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setCurrency([]);
    } finally {
      setCurrLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      // fetchExpenses();
      fetchCurrency();
      //   fetchTotalExpenses();
    }
  }, [bearer, currentPage]);


  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(`${BASE_URL}/fetch-all-currencies`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        const options = Array.isArray(res.data.data)
          ? res.data.data.map((item) => ({
            value: item.id, // use only id
            label: item.name || item.code,
          }))
          : [];
        setCurrencyOptions(options);
      } catch (err) {
        setCurrencyOptions([]);
      }
    };
    fetchCurrencies();
  }, []);

  useEffect(() => {
    const fetchTaxes = async () => {
      try {
        const token = localStorage.getItem("userToken");
        const res = await axios.get(`${BASE_URL}/taxes`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        // const options = Array.isArray(res.data.data)
        //   ? res.data.data.map((item) => ({
        //     value: item.id, // use only id
        //     label: item.name || item.code,
        //   }))
        //   : [];
        const options = res.data.data
          // ? res.data.data.map((item) => ({
          //   value: item.id, // use only id
          //   label: item.name || item.code,
          // }))
          // : [];
        setTaxOptions(options);
      } catch (err) {
        setTaxOptions([]);
      }
    };
    fetchTaxes();
  }, []);
  const taxSelectOptions = taxOptions.map(tax => ({
    value: tax.id,
    label: `${tax.short_name} - ${tax.rate}`,
    shortName: tax.short_name.toUpperCase(), // VAT / WHT
  }));
  
  // const selectedTaxIds = tax.map(item => item.value);



  const fetchBank = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/account/all`, { headers });
      const results = response.data?.data;

      const opt1 = results.map((item) => ({
        value: item.id,
        label: item.gl_name,
        gl_code: item.gl_code,
      }));

      console.log(response);
      setBankOptions(opt1);

    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setBankOptions([]);
    } finally {
      setIsLoading(false);
    }
  };

    const fetchBank1 = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/account/payables_and_expenses`, { headers });
      const results = response.data?.data;

      const opt1 = results.map((item) => ({
        value: item.id,
        label: item.gl_name,
        gl_code: item.gl_code,
      }));

      console.log(response);
      setBankOptions1(opt1);

    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setBankOptions1([]);
    } finally {
      setIsLoading(false);
    }
  };


  const fetchBank2 = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/account/payables`, { headers });
      const results = response.data?.data;

      const opt1 = results.map((item) => ({
        value: item.id,
        label: item.gl_name,
      }));
      console.log(response);
      setBankOptions2(opt1);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setBankOptions2([]);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchPaymentModeNew = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/income/get-payment-method`, { headers });
      const results = response.data?.data;
      console.log("newresult", results);
      const options = results.map((item) => ({
        label: item.name || item.code,
        value: item.id,
        // symbol: item.symbol
      }));
      setPaymentMode(options);

    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setPaymentMode([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchBank();
      fetchBank1();
      fetchBank2();
      fetchPaymentModeNew();
    }
  }, [bearer]);





  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(`${BASE_URL}/v1/beneficiary`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        // Assuming response data is an array of currencies or customers
        const options = Array.isArray(res.data.data)
          ? res.data.data.map((item) => ({
            value: item.id,
            label: item.name,
          }))
          : [];
        setCustomerOptions(options);
      } catch (err) {
        setCustomerOptions([]);
      }
    };
    fetchCustomers();
  }, []);

  useEffect(() => {
    const fetchInvoiceOptions = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(`${BASE_URL}/v1/fetch-pending-purchases-invoice`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        console.log(res);
        // Assuming response data is an array of currencies or customers
        const options = Array.isArray(res.data.data)
          ? res.data.data.map((item) => ({
            value: item.id,
            label: `${item.invoice_number} - ${item.supplier?.name}`,
            balance: item.balance,
          }))
          : [];
        setInvoiceOptions(options);
      } catch (err) {
        setInvoiceOptions([]);
      }
    };
    fetchInvoiceOptions();
  }, []);


  // Skeleton loader rows
  // const SkeletonRows = () => (
  //   <>
  //     {[...Array(5)].map((_, idx) => (
  //       <tr key={idx}>
  //         {Array(10).fill().map((_, i) => (
  //           <td key={i}>
  //             <div className={classes.skeletonLoader}></div>
  //           </td>
  //         ))}
  //       </tr>
  //     ))}
  //   </>
  // );

  // Helper for status
  const statusClass = (status) => {
    if (status === "Success") return classes.greenStatus;
    if (status === "Pending") return classes.yellowStatus;
    return classes.redStatus;
  };

  // useEffect(() => {
  //   const link = document.createElement("link");
  //   link.rel = "stylesheet";
  //   link.href = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css";
  //   document.head.appendChild(link);
  //   return () => {
  //     document.head.removeChild(link);
  //   };
  // }, []);

  const addPayment = async () => {
    setAddPaymenntLoad(true);
    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.post(
        `${BASE_URL}/v1/pay-purchase-invoice`,

        {
          payment_type: selectedRadio,
          transaction_date: paymentDate,
          supplier_id: selectedCustomer?.value,
          supplier: customerName,
          description: description,
          // payment_mode: selectedPaymentMode?.value,
          currency: selectedCurrency?.value,
          amount: amount,
          credit: selectedBank?.value,
          debit: selectedBank2?.value,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });

      Swal.fire({
        imageUrl: verified,
        title: 'Success!',
        text: response.data.message,
        confirmButtonText: "Okay",
        imageWidth: 48,
        imageHeight: 48,
        customClass: {
          title: classes.myTitle,
          popup: classes.myText,
          confirmButton: classes.myButton,
        },
        allowOutsideClick: false,
        preConfirm: () => {
          Swal.close();
        }
      });

      fetchInvoices();
      handleClose1();
      setDescription("");
      setAmount("");
      setCustomerName("");
      setPaymentDate("");
      setSelectedRadio("");
      setSelectedBank(null);
      setSelectedBank2(null);
      setSelectedCurrency(null);
      setSelectedCustomer(null);
      setSelectedPaymentMode(null);

    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          imageUrl: crop,
          imageWidth: 48,
          imageHeight: 48,
          title: "Failed!",
          confirmButtonText: "Okay",
          text: JSON.stringify(error.response.data.message),
          customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myDeclineButton,
          },
          allowOutsideClick: false, // Prevent closing by clicking outside
          preConfirm: () => {
            Swal.close(); // Explicitly close the modal
          },
        });
      }
    } finally {
      setAddPaymenntLoad(false);
    }
  };

  const deletePayment = async (id) => {
    // 1. Confirm deletion first
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      // Match your custom classes from the guide
      customClass: {
        title: classes.myTitle,
        popup: classes.myText,
        // confirmButton: classes.myDeclineButton, 
      },
    });

    if (result.isConfirmed) {
      try {
        // 2. GET Request (Passing ID via query params)
        const response = await axios.get(
          `${BASE_URL}/delete-payable-entries?id=${id}`, // Appending ID to URL
          {
            headers: {
              Authorization: `Bearer ${bearer}`,
              Accept: "application/json",
            },
          }
        );

        // 3. Success Alert (Matching your guide)
        Swal.fire({
          imageUrl: verified, // Make sure 'verified' is imported
          title: "Deleted!",
          text: response.data.message || "Entry deleted successfully.",
          confirmButtonText: "Okay",
          imageWidth: 48,
          imageHeight: 48,
          customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myButton,
          },
          allowOutsideClick: false,
          preConfirm: () => {
            Swal.close();
          }
        });

        // 4. Refresh Data
        fetchPending();

      } catch (error) {
        // 5. Error Handling (Exact match from your guide)
        let errorMessage = "An error occurred. Please try again.";

        if (error.response?.data?.message) {
          if (typeof error.response.data.message === "string") {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join("; ");
          } else if (typeof error.response.data.message === "object") {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }

        Swal.fire({
          imageUrl: crop, // Make sure 'crop' is imported
          imageWidth: 48,
          imageHeight: 48,
          title: "Failed!",
          confirmButtonText: "Okay",
          text: errorMessage,
          customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myDeclineButton,
          },
          allowOutsideClick: false,
        });
      }
    }
  };

  const payablesType = [
    { value: "1", label: "Supllier/Contractor" },
    // { value: "1", label: "Salary Payables" },
    { value: "2", label: "PAYE" },
    { value: "3", label: "Pension" },
    { value: "4", label: "HMO" },
    { value: "5", label: "Purchase of Fixed Asset" },
    // { value: "5", label: "General" },
  ];

  const addPayment2 = async () => {
    setAddPaymenntLoad2(true);

    try {
      // ALWAYS USE FORMDATA
      const formData = new FormData();

      formData.append("transaction_date", selectedDate);
      formData.append("type", selectedPayableType?.value);
      formData.append("type_name", selectedPayableType?.label);
      formData.append("description", description);
      formData.append("supplier_id", selectedSupplier2?.value);
      formData.append("vat", vatFlag);
      formData.append("wht", whtFlag);


      // formData.append("expense_gl", selectedBank?.value);
      // formData.append("payable_gl", selectedBank2?.value);
      formData.append("currency", selectedCurrency?.value);
      // formData.append("payment_mode", selectedPaymentMode?.value);
      formData.append("amount", amount);
      if (
  selectedPayableType?.value === "1" ||
  selectedPayableType?.value === "5"
) {
  formData.append("expense_gl", selectedBank?.value);
  formData.append("payable_gl", selectedBank2?.value);
}


      // Attach file ONLY if it exists
      if (attachment) {
        formData.append("attached_document", attachment);
      }

      const response = await axios.post(
        `${BASE_URL}/post-payable-entries`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${bearer}`,
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        }
      );

      Swal.fire({
        imageUrl: verified,
        title: "Success!",
        text: response.data.message,
        confirmButtonText: "Okay",
        imageWidth: 48,
        imageHeight: 48,
        customClass: {
          title: classes.myTitle,
          popup: classes.myText,
          confirmButton: classes.myButton,
        },
        allowOutsideClick: false,
      });

      fetchPending();
      handleClose2();

      // RESET FIELDS
      setSelectedDate(null);
      setSelectedPayableType(null);
      setDescription("");
      setSelectedSupplier2(null);
      setSelectedBank(null);
      setSelectedBank2(null);
      setAmount("");
      setAttachment(null); // reset file
      setTax();
    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";

      if (error.response?.data?.message) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }

      Swal.fire({
        imageUrl: crop,
        imageWidth: 48,
        imageHeight: 48,
        title: "Failed!",
        confirmButtonText: "Okay",
        text: errorMessage,
        customClass: {
          title: classes.myTitle,
          popup: classes.myText,
          confirmButton: classes.myDeclineButton,
        },
        allowOutsideClick: false,
      });

    } finally {
      setAddPaymenntLoad2(false);
    }
  };

  const updatePayment = async () => {
    setUpdatePaymentLoading(true); // ✅ Use the update loading state

    try {
      // ALWAYS USE FORMDATA
      const formData = new FormData();

      // 1. IDENTITY (Crucial for Update)
      formData.append("id", updateId);

      // 2. APPEND EDIT VARIABLES
      formData.append("transaction_date", editDate);
      formData.append("type", editPayableType);
      formData.append("description", editDescription);
      formData.append("supplier_id", editSelectedSupplier?.value);
      formData.append("currency", editCurrency?.value);
      formData.append("amount", editAmount);

      // 3. CONDITIONAL LOGIC FOR GL ACCOUNTS (Only if Type is 1)
      // Note: We check against "1" as per your request
      if (editPayableType?.value == "1") {
        formData.append("expense_gl", editSelectedBank?.value);
        formData.append("payable_gl", editSelectedBank2?.value);
      }

      // 4. ATTACHMENT LOGIC
      // If a NEW file is selected, send it (this overrides the old one)
      if (editAttachment) {
        formData.append("attached_document", editAttachment);
      }
      // If user cleared the existing file AND didn't add a new one, send empty to remove it
      else if (!editExistingAttachment && !editAttachment) {
        formData.append("attached_document", "");
      }

      // 5. API CALL
      const response = await axios.post(
        `${BASE_URL}/update-payable-entries`, // ✅ Updated Endpoint (Check your specific API route name)
        formData,
        {
          headers: {
            Authorization: `Bearer ${bearer}`,
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // 6. SUCCESS ALERT
      Swal.fire({
        imageUrl: verified,
        title: "Success!",
        text: response.data.message,
        confirmButtonText: "Okay",
        imageWidth: 48,
        imageHeight: 48,
        customClass: {
          title: classes.myTitle,
          popup: classes.myText,
          confirmButton: classes.myButton,
        },
        allowOutsideClick: false,
      });

      // 7. CLEANUP
      fetchPending(); // Refresh table
      setShowUpdateModal(false); // ✅ Close the Update Modal

      // Optional: Reset edit fields (usually not strictly necessary as they re-populate on click)
      setEditAttachment(null);

    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";

      if (error.response?.data?.message) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }

      Swal.fire({
        imageUrl: crop,
        imageWidth: 48,
        imageHeight: 48,
        title: "Failed!",
        confirmButtonText: "Okay",
        text: errorMessage,
        customClass: {
          title: classes.myTitle,
          popup: classes.myText,
          confirmButton: classes.myDeclineButton,
        },
        allowOutsideClick: false,
      });

    } finally {
      setUpdatePaymentLoading(false); // ✅ Turn off update loading
    }
  };

  const handleBankChangeNew22 = (selectedOption) => {
    setSelectedPayableType(selectedOption);
    if (selectedOption) {
      fetchPayablessss(selectedOption.value); // pass the ID directly
    }
  };

const fetchPayablessss = async (bankId) => {
  setAddPaymenntLoad(true);
  try {
    const token = localStorage.getItem("userToken");
    console.log(token);
    const response = await axios.get(
      `${BASE_URL}/beneficiary/get-selected-suppliers`,
      {
        params: { id: bankId }, // ✅ query string
        headers: {
          Authorization: `Bearer ${bearer}`,
          Accept: "application/json",
        },
      }
    );

    const resultss = response.data.data;

    const options = resultss.map((item) => ({
      label: item?.name,
      value: item?.id,
      expense: item?.expense?.gl_name,
      payable: item?.payable?.gl_name,
      gl_codepayable: item?.payable?.gl_code,
      gl_code: item?.expense?.gl_code,
    }));

    // Add "Add New Supplier" as first option
    options.unshift({
      label: '+ Add New Supplier',
      value: 'add_new',
      isAddNew: true
    });

    setSupplierOptions2(options);

  } catch (error) {
    let errorMessage = "An error occurred. Please try again.";
    if (
      error.response &&
      error.response.data &&
      error.response.data.message
    ) {
      if (typeof error.response.data.message === "string") {
        errorMessage = error.response.data.message;
      } else if (Array.isArray(error.response.data.message)) {
        errorMessage = error.response.data.message.join("; ");
      } else if (typeof error.response.data.message === "object") {
        errorMessage = JSON.stringify(error.response.data.message);
      }
    }

    Swal.fire({
      imageUrl: crop,
      imageWidth: 48,
      imageHeight: 48,
      title: "Failed!",
      confirmButtonText: "Okay",
      text: errorMessage,
      customClass: {
        title: classes.myTitle,
        popup: classes.myText,
        confirmButton: classes.myDeclineButton,
      },
      allowOutsideClick: false,
      preConfirm: () => Swal.close(),
    });
  } finally {
    setAddPaymenntLoad(false);
  }
};

  // Add these functions after fetchPayablessss function

  const handleSupplierModalClose = () => {
    setShowSupplierModal(false);
    setSupplierFullName("");
    setSupplierEmail("");
    setSupplierPhone("");
    setSupplierAddress("");
    setRows([{ bankName: "", accName: "", accNo: "" }]);
  };

  const addRow = () =>
    setRows([...rows, { bankName: "", accName: "", accNo: "" }]);

  const deleteRow = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
  };

  const handleChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

  const createBeneficiary = async () => {
    setSupplierLoading(true);
    try {
      const bankAccounts = rows.map(item => item.accNo);
      const accountNames = rows.map(item => item.accName);
      const bankNames = rows.map(item => item.bankName);

      const response = await axios.post(`${BASE_URL}/beneficiary/add_new`,
        {
          name: supplierFullName,
          email: supplierEmail,
          phone_number: supplierPhone,
          address: supplierAddress,
          bank_name: bankNames,
          account_name: accountNames,
          bank_account: bankAccounts
        },
        { headers }
      );

      Swal.fire({
        imageUrl: verified,
        title: 'Success!',
        text: response.data.message,
        confirmButtonText: "Okay",
        imageWidth: 48,
        imageHeight: 48,
        customClass: {
          title: classes.myTitle,
          popup: classes.myText,
          confirmButton: classes.myButton,
        },
        allowOutsideClick: false,
      });

      handleSupplierModalClose();

      // Refresh the supplier list after adding new supplier
      if (selectedPayableType) {
        fetchPayablessss(selectedPayableType.value);
      }

    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";

      if (error.response?.data?.message) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }

      Swal.fire({
        imageUrl: crop,
        imageWidth: 48,
        imageHeight: 48,
        title: "Failed!",
        confirmButtonText: "Okay",
        text: errorMessage,
        customClass: {
          title: classes.myTitle,
          popup: classes.myText,
          confirmButton: classes.myDeclineButton,
        },
        allowOutsideClick: false,
      });
    } finally {
      setSupplierLoading(false);
    }
  };

  const handleNavCheque = () => {
    if (selectedRows.length !== 1) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: selectedRows.length === 0 ? 'Please select a row to generate a cheque!' : 'Please select only one row to generate a cheque!',
      });
      return;
    }
    const selectedRow = selectedRows[0]; // Get the selected row object
    const { id, description, amount, supplier, date_of_invoice, invoice_number, transaction_date, amountToPay } = selectedRow; // Destructure the selected row object
    const selectedData = { id, amountToPay, description, amount, supplier, date_of_invoice, invoice_number, transaction_date, selectedBank, selectedDate }; // Create a new object with the required properties
    // console.log(selectedData, "pending payment");
    // console.log(selectedData)
    // return;
    navigate('/payment/cheque', { state: selectedData });
  }




  const handleGeneratePaymentInstruction = () => {
    if (selectedRows.length === 0) return;
    setShowPaymentModal(true);
  };


  const handleConfirmPaymentInstruction = () => {
    const rowsToPass = (selectedRows.length > 0 ? selectedRows : tableData).map((row) => ({
      ...row,
      amountToPay: row.amountToPay ?? row.balance
    }));

    navigate('/print_instructn', {
      state: { rowsToPass, selectedBank, selectedDate, selectedBankName, selectedBankAc, description }
    });
    setShowPaymentModal(false);
  };



  //  const handlePrint = (rowData) => {
  //   navigate("/invoice-previeww", {
  //     state: {
  //       invoiceNumber: rowData.invoice_number,
  //       invoiceDate: rowData.invoice_date,
  //       dueDate: rowData.due_date,
  //       customer: {
  //         name: rowData.customer_name,
  //         phone_number: rowData.customer_phone,
  //         email: rowData.customer_email,
  //       },
  //       items: rowData.items,
  //       total: rowData.total,
  //     },
  //   });
  // };

  const handlePrint = (rowData) => {
    navigate("/invoice-previeww", {
      state: { invoice: rowData },
    });
  };


  const getTaxRate = (selections) => {
    const hasVAT = selections.some(t => t.shortName === "VAT");
    const hasWHT = selections.some(t => t.shortName === "WHT");
  
    if (hasVAT && hasWHT) return 0.10; // 10%
    if (hasVAT) return 0.075;          // 7.5%
    if (hasWHT) return 0.025;          // 2.5%
  
    return 0;
  };
  
  const handleTaxChange = (selectedOptions) => {
    const selections = selectedOptions ?? [];
    setTax(selections);
  
    // ---- DESCRIPTION LOGIC ----
    if (selections.length > 0) {
      setTaxDescription(selections.map(opt => opt.label).join(", "));
    } else {
      setTaxDescription("");
    }
  
    // ---- INDIVIDUAL FLAGS ----
    const hasVAT = selections.some(opt => opt.shortName === "VAT");
    const hasWHT = selections.some(opt => opt.shortName === "WHT");
  
    setVatFlag(hasVAT ? 1 : 0);
    setWhtFlag(hasWHT ? 1 : 0);
  };
  

  useEffect(() => {
    const taxRate = vatFlag && whtFlag ? 0.10 : vatFlag ? 0.075 : whtFlag ? 0.025 : 0;
  
    const calculatedTax = (Number(amount) || 0) * taxRate;
    const calculatedTotal = (Number(amount) || 0) + calculatedTax;
  
    setTaxAmount(calculatedTax);
    setTotalAmount(calculatedTotal);
  }, [amount, vatFlag, whtFlag]);
  
  
  
 const filteredTableData = tableData.filter((item) => {
  if (!searchTerm) return true;

  const query = searchTerm.toLowerCase();

  return (
    item?.supplier?.name?.toLowerCase().includes(query) ||
    item?.customer?.name?.toLowerCase().includes(query) ||
    item?.description?.toLowerCase().includes(query) ||
    item?.invoice_number?.toLowerCase().includes(query) ||
    item?.transaction_date?.toLowerCase().includes(query) ||
    String(item?.amount)?.includes(query)
  );
});
 
  




  return (
    <div>
      <HeaderNav activePage={pageMap[location.pathname]} />

      <div className={classes.Container}>
        {/* <div className={classes.actions}>

                    <button className={`${classes.btnss} ${classes.greens}`}>New Sales Invoice</button>
                    <button className={classes.btns}>New Purchase Invoice</button>
                    <button className={classes.btns}>All Invoices</button>
                    <button className={classes.btns}>Product & Services </button>

                </div> */}
        <div className={classes.actionsbtn}>
          <button className={classes.btns}>New Sales Invoice</button>
          <button className={classes.btns}>New Purchase Invoice</button>
          <button className={classes.btns}>All Invoices</button>
          <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
        </div>

        <header className={classes.Header}>
          <h2 className={classes.Title}>Payable Entries</h2>
          <h1 className={classes.Titles}>
            Manage your purchase transactions, supplier invoices, and payments.
          </h1>
        </header>

        <Row className={classes.laysbtns}>
          <Col md={3}>
            <div className={classes.thrdkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Total Payable</p>
                <p className={classes.kdptg1}>₦0.00</p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>This month</p>
                </div>
              </div>
            </div>
          </Col>
          <Col md={3}>
            <div className={classes.frtkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Completed</p>
                <p className={classes.kdptg2}>₦0.00</p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>Completed payments</p>
                </div>
              </div>
            </div>
          </Col>
          <Col md={3}>
            <div className={classes.fiftkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Overdue</p>
                <p className={classes.kdptg3}>₦0.00</p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>Past due dates</p>
                </div>
              </div>
            </div>
          </Col>
          <Col md={3}>
            <div className={classes.frstkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Pending</p>
                <p className={classes.kdptg4}>₦0.00</p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>Total invoices</p>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <div className={classes.headerActions}>
          <div className={classes.actionsRight}>
            <div className={classes.inputWrapper}>
              <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
              <input
  type="text"
  className={classes.searchBar}
  placeholder="Search payables..."
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
/>

            </div>
            {/* <div className={classes.selectWrapper}>
              <select className={classes.dropdown}>
                <option value="">All Status</option>
                <option value="Paid">Paid</option>
                <option value="Pending">Pending</option>
                <option value="Overdue">Overdue</option>
                <option value="Draft">Draft</option>
              </select>
              <span className={classes.dropdownArrow}>▼</span>
            </div> */}

            {/* <div className={classes.inputWrapper}>
              <input type="text" className={classes.searchBars} placeholder="Filter..." />
              <img src={filter} alt="Filter" className={classes.inputIcon} />
            </div> */}
          </div>
          <div className={classes.actionsLeft}>
            {/* <button className={classes.btnss} onClick={handleGeneratePaymentInstruction} disabled={selectedRows.length === 0}> + Proceed</button> */}
            <button className={classes.btnss} onClick={handleShow2}> + Create New</button>
          </div>
        </div>

        <div className={classes.invoicecont}>
          <table className={classes.invoiceTable}>
            <table className={classes.invoiceTable}>
              <thead style={{ whiteSpace: "nowrap" }}>
                <tr>
                  <th style={{ width: "5%" }}>S/N</th>
                  <th style={{ width: "7%" }}>Transaction Date</th>
                  <th style={{ width: "25%" }}>Beneficiary Name</th>
                  <th style={{ width: "45%" }}>Description</th>
                  <th style={{ width: "8%" }}>Invoice Number</th>
                  <th style={{ width: "10%" }}>Total Amount</th>
                  <th style={{ width: "10%" }}>Balance</th>
                  <th style={{ width: "10%" }}>Action</th>
                  {/* <th>Amount</th>
                  <th>Actions</th> */}
                </tr>
              </thead>
              <tbody>

                {isLoadingPayee
                  ? Array(5)
                    .fill()
                    .map((_, idx) => (
                      <tr key={idx}>
                        {Array(7)
                          .fill()
                          .map((_, i) => (
                            <td key={i}>
                              <Skeleton height={20} style={{ marginBottom: 10 }} />
                            </td>
                          ))}
                      </tr>
                    ))
                  : filteredTableData.length === 0 ? (
                    <tr>
                      <td colSpan={10} style={{ textAlign: "center" }}>
                        No Payee found.
                      </td>
                    </tr>
                  ) : (
                    filteredTableData.map((item, index) => (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td>{item.transaction_date}</td>
                        <td>{item.supplier?.name || item?.customer?.name}</td>
                        <td>{item.description}</td>
                        <td>{item.invoice_number}</td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(item.amount).toLocaleString('en-US', {
                            minimumIntegerDigits: 1,
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(item.balance).toLocaleString('en-US', {
                            minimumIntegerDigits: 1,
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })}
                        </td>
                        {/* <td>{item.created_at ? item.created_at.split("T")[0] : ""}</td> */}
                        <td className={classes.actions}>
                          <Pen
                            size={16}
                            className={classes.editIcon}
                            style={{ cursor: "pointer" }}
                            onClick={() => handleEditClick(item)}
                          />
                          <Trash2 size={16} className={classes.deleteIcon} onClick={() => deletePayment(item.id)} />
                        </td>

                      </tr>
                    ))
                  )}
              </tbody>
            </table>
          </table>
          <div className={classes.paginationContainer}>
            <div className={classes.paginationControls}>
              <button
                onClick={handlePrevPage}
                disabled={currentPage === 1}
              >Previous</button>
              {[...Array(totalPages)].map((_, page) => {
                // Show only 5 pages or less if available
                if (page < 5 || page === currentPage - 1 || page === totalPages - 1) {
                  return (
                    <button className={classes.active} key={page + 1}
                      style={{
                        color: page + 1 === currentPage ? '#ffffff' : '#000',
                        backgroundColor: page + 1 === currentPage ? '#174384' : 'gainsboro',
                        cursor: "pointer"
                      }}
                      onClick={() => setCurrentPage(page + 1)}
                    > {page + 1}
                    </button>
                  );
                }
                return null;
              })}
              <button
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
              >Next
              </button>
              <span className={classes.pageText}>Displaying {startIndexx} - {endIndexx} of {totalEntries}</span>
            </div>
          </div>
        </div>
      </div>
      <Modal show={show1} onHide={handleClose1} animation={false} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>New Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form style={{ paddingLeft: "25px", paddingRight: "25px" }}>
            <Row style={{ marginBottom: "10px" }}>
              <Col md={6}>
                <Form.Check
                  label="Supplier/Contractor"
                  name="group1"
                  type="radio"
                  id="supplier"
                  value="supplier"
                  checked={selectedRadio === "supplier"}
                  onChange={handleRadioChange}
                  className={classes.radioGreen}
                />
              </Col>
              <Col md={6}>
                <Form.Check
                  label="General Payment"
                  name="group1"
                  type="radio"
                  id="general"
                  value="general"
                  checked={selectedRadio === "general"}
                  onChange={handleRadioChange}
                  className={classes.radioGreen}
                />
              </Col>
            </Row>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Row style={{ marginBottom: "15px" }}>
                {selectedRadio === "supplier" && (
                  <Col md={12} style={{ marginBottom: 10 }}>
                    <Row>
                      <Col md={3} style={{ textAlign: "right" }}>
                        <label>Payment to:</label>
                      </Col>
                      <Col md={9}>
                        <Select
                          options={customerOptions}
                          value={selectedCustomer}
                          onChange={setSelectedCustomer}
                          placeholder="Select Supplier"
                          isClearable
                          classNamePrefix="react-select"
                          required
                        />
                      </Col>
                    </Row>
                  </Col>
                )}
                {selectedRadio === "general" && (
                  <Col md={12} style={{ marginBottom: 10 }}>
                    <Row>
                      <Col md={3} style={{ textAlign: "right" }}>
                        <label>Payment to:</label>
                      </Col>
                      <Col md={9}>
                        <Form.Control
                          type="text"
                          value={customerName}
                          onChange={(e) => {
                            const value = e.target.value;
                            const filteredValue = value.replace(/[^a-zA-Z0-9.@,\- ]/g, '');
                            setCustomerName(filteredValue);
                          }}
                          required
                          style={{ width: "100%" }}
                        />
                      </Col>
                    </Row>
                  </Col>
                )}
                <Col md={12} style={{ marginBottom: 10 }}>
                  <Row>
                    <Col md={3} style={{ textAlign: "right" }}>
                      <label style={{ width: "100%" }}>Date:</label>
                    </Col>
                    <Col md={9}>
                      <Form.Control
                        type="date"
                        value={paymentDate}
                        onChange={e => setPaymentDate(e.target.value)}
                        required
                        style={{ width: "100%" }}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col md={12} style={{ marginBottom: 10 }}>
                  <Row>
                    <Col md={3} style={{ textAlign: "right" }}>
                      <label style={{ width: "100%" }}>Description:</label>
                    </Col>
                    <Col md={9}>
                      <Form.Control
                        as="textarea"
                        value={description}
                        rows={1}
                        onChange={(e) => {
                          const value = e.target.value;
                          const filteredValue = value.replace(/[^a-zA-Z0-9.@,\- ]/g, '');
                          setDescription(filteredValue);
                        }}
                        required
                        style={{ width: "100%" }}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col md={12}>
                  <Row>
                    <Col md={3} style={{ textAlign: "right" }}>
                      <label>Mode:</label>
                    </Col>
                    <Col md={9}>
                      <Select
                        options={paymentMode}
                        value={selectedPaymentMode}
                        onChange={setSelectedPaymentMode}
                        placeholder="Payment Mode"
                        isClearable
                        classNamePrefix="react-select"
                        required
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col md={12} style={{ marginBottom: 10 }}>
                  <Row>
                    <Col md={3} style={{ textAlign: "right" }}>
                      <label>Currency:</label>
                    </Col>
                    <Col md={9}>
                      <Row>
                        <Col md={5}>
                          <Select
                            options={currencyOptions}
                            value={selectedCurrency}
                            onChange={setSelectedCurrency}
                            placeholder="Currency"
                            isClearable
                            classNamePrefix="react-select"
                            required
                          />
                        </Col>
                        <Col md={7}>
                          <Row>
                            <Col md={4} style={{ textAlign: "right" }}>
                              <label style={{ width: "100%" }}>Amount:</label>
                            </Col>
                            <Col md={8}>
                              <CurrencyInput
                                id="total-amount"
                                name="totalAmount"
                                value={amount}
                                decimalsLimit={2}
                                onValueChange={(value) => setAmount(value)}
                                // prefix="₦"
                                groupSeparator=","
                                placeholder="Amount"
                                className={`form-control ${classes.optioncss}`}
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
                <Col md={12}>
                  <Row>
                    <Col md={3} style={{ textAlign: "right" }}>
                      <label>Expenses:</label>
                    </Col>
                    <Col md={9}>
                      <Row>
                        <Col md={5}>
                          <Select
                            options={bankOptions}
                            value={selectedBank}
                            onChange={setSelectedBank}
                            placeholder="Account"
                            isClearable
                            classNamePrefix="react-select"
                            required
                          />
                        </Col>
                        <Col md={7}>
                          <Row>
                            <Col md={4} style={{ textAlign: "right" }}>
                              <label style={{ width: "100%" }}>Payables:</label>
                            </Col>
                            <Col md={8}>
                              <Select
                                options={bankOptions2}
                                value={selectedBank2}
                                onChange={setSelectedBank2}
                                placeholder="Account"
                                isClearable
                                classNamePrefix="react-select"
                                required
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer style={{ paddingLeft: "25px", paddingRight: "25px" }}>
          <Button variant="light" onClick={handleClose1}>
            Go back
          </Button>
          <Button variant="success" onClick={addPayment} disabled={addpaymenntLoad} className={classes.btnss}>
            {addpaymenntLoad ? (
              <>
                <Spinner size="sm" />
                <span style={{ marginLeft: "5px" }}>
                  Processing, Please wait...
                </span>
              </>
            ) : (
              "Save Payment"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={show2} onHide={handleClose2} size="xl"
        dialogClassName={classes.customModal} centered >
        <Modal.Header closeButton style={{ padding: "15px 30px 10px 0", fontSize: "13px" }}>
          <Modal.Title style={{ fontSize: 18, padding: "10px 20px 0px 25px" }}><b>Add New Payable</b></Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "10px 30px 10px 30px" }}>
          <Row style={{ marginTop: 10, fontSize: "13px" }}>
            <Col md={12} style={{ marginBottom: 15 }}>
              <Row>
                <Col md={4}>
                  <Form.Label style={{ marginBottom: 2, padding: 0, fontWeight: 'bold' }}>Payable Type</Form.Label>
                  <Select
                    options={payablesType}
                    value={selectedPayableType}
                    onChange={handleBankChangeNew}
                    placeholder="Select Payable Type"
                    isClearable
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ✅ keeps it on top

                      control: (base, state) => ({
                        ...base,
                        fontSize: "12px",
                        minHeight: "32px",
                        height: "32px",
                        padding: "0 4px",
                        borderColor: state.isFocused ? "#2684ff" : base.borderColor,
                        boxShadow: state.isFocused ? "0 0 0 1px #2684ff" : "none",
                      }),

                      valueContainer: (base) => ({
                        ...base,
                        padding: "0 6px",
                        height: "28px",
                      }),

                      indicatorsContainer: (base) => ({
                        ...base,
                        height: "28px",
                      }),

                      option: (base, state) => ({
                        ...base,
                        fontSize: "12px",
                        backgroundColor: state.isFocused ? "#f0f0f0" : "white",
                        color: "black",
                      }),

                      menuList: (base) => ({
                        ...base,
                        maxHeight: "200px",
                        overflowY: "auto",
                      }),
                    }}
                  />
                </Col>
                <Col md={4}>
                  <Form.Label style={{ marginBottom: 2, padding: 0, fontWeight: 'bold' }}>Supplier</Form.Label>
                  <Select
                    options={supplierOptions2}
                    value={selectedSupplier2}
                    onChange={(option) => {
                      if (option?.isAddNew) {
                        // Open the supplier modal from the first file
                        setShowSupplierModal(true);
                        setSelectedSupplier2(null);
                      } else if (option) {
                        setSelectedSupplier2(option);
                        setAccountExpenses(option?.expense || "");
                        setAccountPayables(option?.payable || "");
                        setAccountCode(option?.gl_code || "");
                      } else {
                        setSelectedSupplier2(null);
                        setAccountExpenses("");
                        setAccountPayables("");
                        setAccountCode("");
                      }
                    }}
                    placeholder="Select Supplier"
                    isClearable
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ✅ keeps it on top

                      control: (base, state) => ({
                        ...base,
                        fontSize: "12px",
                        minHeight: "32px",
                        height: "32px",
                        padding: "0 4px",
                        borderColor: state.isFocused ? "#2684ff" : base.borderColor,
                        boxShadow: state.isFocused ? "0 0 0 1px #2684ff" : "none",
                      }),

                      valueContainer: (base) => ({
                        ...base,
                        padding: "0 6px",
                        height: "28px",
                      }),

                      indicatorsContainer: (base) => ({
                        ...base,
                        height: "28px",
                      }),

                      option: (base, state) => ({
                        ...base,
                        fontSize: "12px",
                        backgroundColor: state.isFocused ? "#f0f0f0" : "white",
                        color: "black",
                      }),

                      menuList: (base) => ({
                        ...base,
                        maxHeight: "200px",
                        overflowY: "auto",
                      }),
                    }}
                  />
                </Col>
                <Col md={4}>
                  <Form.Label style={{ marginBottom: 2, padding: 0, fontWeight: 'bold' }}>Transaction Date</Form.Label>
                  <Form.Control
                    type="date"
                    // autoFocus
                    value={selectedDate}
                    onChange={handleDateChange}
                    name="date"
                    // min={minDate}
                    // max={maxDate}
                    style={{ fontSize: "13px", height: 32 }}
                  />
                </Col>
              </Row>
            </Col>
            <Col md={12} style={{ marginBottom: 15 }}>
              <Row>
                <Col md={6}>
                  <Form.Label style={{ marginBottom: 2, padding: 0, fontWeight: 'bold' }}>Description</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Description"
                    // autoFocus
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    style={{ fontSize: "13px", height: 32 }}
                  />
                </Col>
                {/* <Col md={3}>
                    <Form.Label style={{ marginBottom: 2, padding: 0, fontWeight: 'bold' }}>Mode of Payment</Form.Label>
                      <Select
                        options={paymentMode}
                        value={selectedPaymentMode}
                        onChange={setSelectedPaymentMode}
                        placeholder="Select Payment Mode"
                        isClearable
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),

                          control: (base, state) => ({
                            ...base,
                            fontSize: "12px",
                            minHeight: "32px",
                            height: "32px",
                            padding: "0 4px",
                            borderColor: state.isFocused ? "#2684ff" : base.borderColor,
                            boxShadow: state.isFocused ? "0 0 0 1px #2684ff" : "none",
                          }),

                          valueContainer: (base) => ({
                            ...base,
                            padding: "0 6px",
                            height: "28px",
                          }),

                          indicatorsContainer: (base) => ({
                            ...base,
                            height: "28px",
                          }),

                          option: (base, state) => ({
                            ...base,
                            fontSize: "12px",
                            backgroundColor: state.isFocused ? "#f0f0f0" : "white",
                            color: "black",
                          }),

                          menuList: (base) => ({
                            ...base,
                            maxHeight: "200px",
                            overflowY: "auto",
                          }),
                        }}
                      />
                  </Col> */}
                <Col md={3}>
                  <Form.Label style={{ marginBottom: 2, padding: 0, fontWeight: 'bold' }}>Currency</Form.Label>
                  <Select
                    options={currencyOptions}
                    value={selectedCurrency}
                    onChange={setSelectedCurrency}
                    placeholder="Currency"
                    isClearable
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ✅ keeps it on top

                      control: (base, state) => ({
                        ...base,
                        fontSize: "12px",
                        minHeight: "32px",
                        height: "32px",
                        padding: "0 4px",
                        borderColor: state.isFocused ? "#2684ff" : base.borderColor,
                        boxShadow: state.isFocused ? "0 0 0 1px #2684ff" : "none",
                      }),

                      valueContainer: (base) => ({
                        ...base,
                        padding: "0 6px",
                        height: "28px",
                      }),

                      indicatorsContainer: (base) => ({
                        ...base,
                        height: "28px",
                      }),

                      option: (base, state) => ({
                        ...base,
                        fontSize: "12px",
                        backgroundColor: state.isFocused ? "#f0f0f0" : "white",
                        color: "black",
                      }),

                      menuList: (base) => ({
                        ...base,
                        maxHeight: "200px",
                        overflowY: "auto",
                      }),
                    }}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row style={{ fontSize: "12px" }}>
            {((selectedPayableType?.value == 2) || (selectedPayableType?.value == 3) || (selectedPayableType?.value == 4)) ? (
              <>
                {/* <Col md={4} style={{ marginBottom: 10 }}>
                  <Form.Label style={{ marginBottom: 2, padding: 0 }}>Account Expenses</Form.Label>
                  <Form.Control
                    type="text"
                    disabled
                    value={accountExpenses}
                    onChange={(e) => setAccountExpenses(e.target.value)}
                    style={{ fontSize: "13px", height: 38 }}
                  />
                </Col> */}
                <Col md={4}>
                  <Form.Label style={{ marginBottom: 2, padding: 0, fontWeight: 'bold' }}>Account Payables</Form.Label>
                  <Form.Control
                    type="text"
                    disabled
                    value={accountPayables}
                    onChange={(e) => setAccountPayables(e.target.value)}
                    style={{ fontSize: "13px", height: 32 }}
                  />
                </Col>
                <Col md={4}>
                  <Form.Label style={{ marginBottom: 2, padding: 0, fontWeight: 'bold' }}>Amount</Form.Label>
                  <CurrencyInput
                    id="total-amount"
                    name="totalAmount"
                    value={amount}
                    decimalsLimit={2}
                    onValueChange={(value) => setAmount(value)}
                    // prefix="₦"
                    groupSeparator=","
                    placeholder="Enter Amount"
                    style={{ fontSize: "13px", height: 32, textAlign: "right" }}
                    className={`form-control ${classes.optioncss}`}
                  />
                </Col>
              </>
            ) : (
              <>
                {/* <Col md={4} style={{ marginBottom: 10 }}>
                <Form.Label style={{ marginBottom: 2, padding: 0 }}>Account Expenses</Form.Label>
                <Select
                  options={bankOptions}
                  value={selectedBank}
                  onChange={setSelectedBank}
                  placeholder="Select an Option"
                  isClearable
                  classNamePrefix="react-select"
                  required
                />
              </Col> */}
                <Col md={4}>
                  <Form.Label style={{ marginBottom: 2, padding: 0, fontWeight: 'bold' }}>Account Payables</Form.Label>
                  <Select
                    options={bankOptions2}
                    value={selectedBank2}
                    onChange={setSelectedBank2}
                    placeholder="Select an Option"
                    isClearable
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ✅ keeps it on top

                      control: (base, state) => ({
                        ...base,
                        fontSize: "12px",
                        minHeight: "32px",
                        height: "32px",
                        padding: "0 4px",
                        borderColor: state.isFocused ? "#2684ff" : base.borderColor,
                        boxShadow: state.isFocused ? "0 0 0 1px #2684ff" : "none",
                      }),

                      valueContainer: (base) => ({
                        ...base,
                        padding: "0 6px",
                        height: "28px",
                      }),

                      indicatorsContainer: (base) => ({
                        ...base,
                        height: "28px",
                      }),

                      option: (base, state) => ({
                        ...base,
                        fontSize: "12px",
                        backgroundColor: state.isFocused ? "#f0f0f0" : "white",
                        color: "black",
                      }),

                      menuList: (base) => ({
                        ...base,
                        maxHeight: "200px",
                        overflowY: "auto",
                      }),
                    }}
                  />
                </Col>
                <Col md={4}>
                  <Form.Label style={{ marginBottom: 2, padding: 0, fontWeight: 'bold' }}>Amount</Form.Label>
                  <CurrencyInput
                    id="total-amount"
                    name="totalAmount"
                    value={amount}
                    decimalsLimit={2}
                    onValueChange={(value) => setAmount(value)}
                    // prefix="₦"
                    groupSeparator=","
                    placeholder="Enter Amount"
                    style={{ fontSize: "13px", height: 32, textAlign: "right" }}
                    className={`form-control ${classes.optioncss}`}
                  />
                </Col>
              </>
            )}
            <Col md={4}>
              <Form.Label style={{ marginBottom: 2, padding: 0 }}>Upload Supporting Document (PDF)</Form.Label>
              <Form.Control
                type="file"
                accept="application/pdf"
                onChange={(e) => setAttachment(e.target.files[0])}
                style={{ fontSize: "13px", height: 32 }}
                className={`form-control ${classes.optioncss}`}
              />
            </Col>
          </Row>
          {/* {selectedPayableType?.value == 1 && (
            <Row style={{ marginTop: 15, fontSize: "12px" }}>
              <Col md={6}>
                <Form.Label style={{ marginBottom: 2, padding: 0 }}>Account Payables</Form.Label>
                <Select
                  options={bankOptions2}
                  value={selectedBank2}
                  onChange={setSelectedBank2}
                  placeholder="Select an Option"
                  isClearable
                  classNamePrefix="react-select"
                  required
                />
              </Col>
            </Row>
            )} */}
          <Modal.Title style={{ fontSize: 18, padding: "15px 20px 15px 0px" }}><b>Account Breakdown</b></Modal.Title>
          <div className={classes.mainTable} style={{ paddingBottom: 30 }}>
            <div className="table-responsive" style={{ maxHeight: '200px', overflowY: 'auto', }}>
              <table className="table display bg-white m-0 card-table">
                <thead style={{ whiteSpace: "nowrap", textAlign: "left", }}>
                  <tr style={{ padding: "2px 10px", margin: "2px 10px", fontSize: 13 }}>
                    <th style={{ position: 'sticky', top: 0, background: '#f5f7fb', zIndex: 2, width: "30%", padding: "7px 10px", margin: "7px 10px" }}>Account Name</th>
                    <th style={{ position: 'sticky', top: 0, background: '#f5f7fb', zIndex: 2, width: "15%", padding: "7px 10px", margin: "7px 10px" }}>Account Code</th>
                    <th style={{ position: 'sticky', top: 0, background: '#f5f7fb', zIndex: 2, textAlign: "right", width: "15%", padding: "7px 10px", margin: "7px 10px" }}>Amount</th>
                    <th style={{ position: 'sticky', top: 0, background: '#f5f7fb', zIndex: 2, textAlign: "right", width: "35%", padding: "7px 10px", margin: "7px 10px" }}>Tax</th>
                    <th style={{ position: 'sticky', top: 0, background: '#f5f7fb', zIndex: 2, textAlign: "right", width: "15%", padding: "7px 10px", margin: "7px 10px" }}>Tax Amount</th>
                    <th style={{ position: 'sticky', top: 0, background: '#f5f7fb', zIndex: 2, textAlign: "right", width: "15%", padding: "7px 10px", margin: "7px 10px" }}>Total Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style={{ padding: "5px 10px", margin: "2px 10px", fontSize: 13 }}>
                    <td style={{ padding: "5px 10px", margin: "2px 10px" }}>
                      {((selectedPayableType?.value == 2) || (selectedPayableType?.value == 3) || (selectedPayableType?.value == 4)) ? (
                        <>
                          <Form.Control
                            type="text"
                            disabled
                            value={accountExpenses}
                            onChange={(e) => setAccountExpenses(e.target.value)}
                            style={{ fontSize: "13px", height: 32 }}
                          />
                        </>
                      ) : (
                        <>
                          <Select
                            options={selectedPayableType?.value == 1  ? bankOptions1  : bankOptions}
                            value={selectedBank}
                            placeholder="Select an Option"
                            isClearable
                            onChange={(option) => {
                              // ✅ Update the selected option to show it inside the box
                              setSelectedBank(option);

                              if (option) {
                                setAccountCode(option?.gl_code || ""); // ✅ auto-fill expense_gl
                              } else {
                                // if cleared, reset values
                                setAccountCode("");
                              }
                            }}
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ✅ keeps it on top

                              control: (base, state) => ({
                                ...base,
                                fontSize: "12px",
                                minHeight: "32px",
                                height: "32px",
                                padding: "0 4px",
                                borderColor: state.isFocused ? "#2684ff" : base.borderColor,
                                boxShadow: state.isFocused ? "0 0 0 1px #2684ff" : "none",
                              }),

                              valueContainer: (base) => ({
                                ...base,
                                padding: "0 6px",
                                height: "28px",
                              }),

                              indicatorsContainer: (base) => ({
                                ...base,
                                height: "28px",
                              }),

                              option: (base, state) => ({
                                ...base,
                                fontSize: "12px",
                                backgroundColor: state.isFocused ? "#f0f0f0" : "white",
                                color: "black",
                              }),

                              menuList: (base) => ({
                                ...base,
                                maxHeight: "200px",
                                overflowY: "auto",
                              }),
                            }}
                          />
                        </>
                      )}
                    </td>
                    <td style={{ padding: "5px 10px", margin: "2px 10px" }}>
                      <Form.Control
                        type="text"
                        value={accountCode}
                        disabled
                        onChange={(e) => setAccountCode(e.target.value)}
                        required
                        style={{ width: "100%", fontSize: "13px", height: 32 }}
                      />
                    </td>
                    <td style={{ textAlign: "right", padding: "5px 10px", margin: "2px 10px" }}>
                      <CurrencyInput
                        id="total-amount"
                        name="totalAmount"
                        value={amount}
                        decimalsLimit={2}
                        disabled
                        onValueChange={(value) => setAmount(value)}
                        // prefix="₦"
                        groupSeparator=","
                        placeholder="Enter Amount"
                        style={{ fontSize: "13px", height: 32, textAlign: "right" }}
                        className={`form-control ${classes.optioncss}`}
                      />
                    </td>
                    <td>
                      {/* <Select
                  isMulti
                  options={taxSelectOptions}
                  value={tax}
                  onChange={(selectedOptions) => {
                    setTax(selectedOptions || []);
                  }}
                  placeholder="Select Tax"
                  styles={{
                    control: (base) => ({
                      ...base,
                      fontSize: "13px",
                      minHeight: "32px",
                    }),
                    menu: (base) => ({
                      ...base,
                      fontSize: "13px",
                    }),
                  }}
                  /> */}

                  <Select
                    isMulti
                    options={taxSelectOptions}
                    value={tax}
                    // onChange={(selectedOptions) => {
                    //   setTax(selectedOptions ?? []);
                    // }}
                    onChange={handleTaxChange}
                    placeholder="Tax"
                    isClearable
                    classNamePrefix="react-select"
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),

                      control: (base, state) => ({
                        ...base,
                        fontSize: "12px",
                        minHeight: "32px",
                        height: "32px",
                        width: "100%",
                        padding: "0 4px",
                        borderColor: state.isFocused ? "#2684ff" : base.borderColor,
                        boxShadow: state.isFocused ? "0 0 0 1px #2684ff" : "none",
                      }),

                      valueContainer: (base) => ({
                        ...base,
                        padding: "0 6px",
                        minHeight: "28px",
                        flexWrap: "nowrap", // ✅ important
                        overflow: "hidden",
                      }),

                      indicatorsContainer: (base) => ({
                        ...base,
                        height: "28px",
                      }),

                      option: (base, state) => ({
                        ...base,
                        fontSize: "12px",
                        backgroundColor: state.isFocused ? "#f0f0f0" : "white",
                        color: "black",
                      }),

                      menuList: (base) => ({
                        ...base,
                        maxHeight: "200px",
                        overflowY: "auto",
                      }),
                    }}
                  />

                    </td>
                    <td style={{ textAlign: "right", padding: "5px 10px", margin: "2px 10px" }}>
                      <CurrencyInput
                        id="total-amount"
                        name="totalAmount"
                        value={taxAmount}
                        decimalsLimit={2}
                        disabled
                        onValueChange={(value) => setTaxAmount(value)}
                        // prefix="₦"
                        groupSeparator=","
                        placeholder="Enter Amount"
                        style={{ fontSize: "13px", height: 32, textAlign: "right" }}
                        className={`form-control ${classes.optioncss}`}
                      />
                    </td>                    <td style={{ textAlign: "right", padding: "5px 10px", margin: "2px 10px" }}>
                      <CurrencyInput
                        id="total-amount"
                        name="totalAmount"
                        value={totalAmount}
                        decimalsLimit={2}
                        disabled
                        onValueChange={(value) => setTotalAmount(value)}
                        // prefix="₦"
                        groupSeparator=","
                        placeholder="Enter Amount"
                        style={{ fontSize: "13px", height: 32, textAlign: "right" }}
                        className={`form-control ${classes.optioncss}`}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer style={{ padding: "40px 30px 10px 30px" }}>
          <Button variant="light" onClick={handleClose2}>
            Go back
          </Button>
          <Button variant="success" onClick={addPayment2} disabled={addpaymenntLoad2} className={classes.btnss}>
            {addpaymenntLoad2 ? (
              <>
                <Spinner size="sm" />
                <span style={{ marginLeft: "5px" }}>
                  Processing, Please wait...
                </span>
              </>
            ) : (
              "Add Payable"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showUpdateModal}
        onHide={() => setShowUpdateModal(false)}
        size="xl"
        dialogClassName={classes.customModal}
        centered
      >
        <Modal.Header closeButton style={{ padding: "15px 30px 10px 0", fontSize: "13px" }}>
          <Modal.Title style={{ fontSize: 18, padding: "10px 20px 0px 25px" }}>
            <b>Update Payable</b>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "10px 30px 10px 30px" }}>
          <Row style={{ marginTop: 10, fontSize: "13px" }}>
            <Col md={12} style={{ marginBottom: 15 }}>
              <Row>
                {/* PAYABLE TYPE */}
                <Col md={4}>
                  <Form.Label style={{ marginBottom: 2, padding: 0, fontWeight: 'bold' }}>Payable Type</Form.Label>
                  <Select
                    isDisabled={true}
                    value={
                      editPayableType?.value == "1" ? { label: 'Suppliers/Contractors', value: '1' } :
                        editPayableType?.value == "3" ? { label: 'Pension', value: '3' } :
                          editPayableType?.value == "4" ? { label: 'HMO', value: '4' } :
                            { label: 'PAYE', value: '2' } // Default fall-through (usually '2')
                    }

                    onChange={setEditPayableType}
                    placeholder="Select Payable Type"
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      control: (base, state) => ({ ...base, fontSize: "12px", minHeight: "32px", height: "32px", borderColor: state.isFocused ? "#2684ff" : base.borderColor, boxShadow: state.isFocused ? "0 0 0 1px #2684ff" : "none" }),
                    }}
                  />
                </Col>

                {/* SUPPLIER */}
                <Col md={4}>
                  <Form.Label style={{ marginBottom: 2, padding: 0, fontWeight: 'bold' }}>Supplier</Form.Label>
                  <Select
                    onChange={(option) => {
                      if (option?.isAddNew) {
                        setShowSupplierModal(true);
                        setSelectedSupplier2(null);
                      } else if (option) {
                        setSelectedSupplier2(option);
                        setAccountExpenses(option?.expense || "");
                        setAccountPayables(option?.payable || "");
                        setAccountCode(option?.gl_code || "");
                      } else {
                        setSelectedSupplier2(null);
                        setAccountExpenses("");
                        setAccountPayables("");
                        setAccountCode("");
                      }
                    }}
                  />
                </Col>

                {/* DATE */}
                <Col md={4}>
                  <Form.Label style={{ marginBottom: 2, padding: 0, fontWeight: 'bold' }}>Transaction Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={editDate} // ✅ NEW VARIABLE
                    onChange={(e) => setEditDate(e.target.value)} // ✅ NEW SETTER
                    name="date"
                    // min={minDate}
                    // max={maxDate}
                    style={{ fontSize: "13px", height: 32 }}
                  />
                </Col>
              </Row>
            </Col>

            <Col md={12} style={{ marginBottom: 15 }}>
              <Row>
                {/* DESCRIPTION */}
                <Col md={6}>
                  <Form.Label style={{ marginBottom: 2, padding: 0, fontWeight: 'bold' }}>Description</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Description"
                    value={editDescription} // ✅ NEW VARIABLE
                    onChange={(e) => setEditDescription(e.target.value)} // ✅ NEW SETTER
                    style={{ fontSize: "13px", height: 32 }}
                  />
                </Col>

                {/* CURRENCY */}
                <Col md={3}>
                  <Form.Label style={{ marginBottom: 2, padding: 0, fontWeight: 'bold' }}>Currency</Form.Label>
                  <Select
                    options={currencyOptions}
                    value={editCurrency} // ✅ NEW VARIABLE
                    onChange={setEditCurrency} // ✅ NEW SETTER
                    placeholder="Currency"
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      control: (base, state) => ({ ...base, fontSize: "12px", minHeight: "32px", height: "32px", borderColor: state.isFocused ? "#2684ff" : base.borderColor, boxShadow: state.isFocused ? "0 0 0 1px #2684ff" : "none" }),
                    }}
                  />
                </Col>
              </Row>
            </Col>
          </Row>

          <Row style={{ fontSize: "12px" }}>
            {/* CONDITIONAL RENDER FOR ACCOUNTS */}
            {((editPayableType?.value == 2) || (editPayableType?.value == 3) || (editPayableType?.value == 4)) ? (
              <>
                <Col md={4}>
                  <Form.Label style={{ marginBottom: 2, padding: 0, fontWeight: 'bold' }}>Account Payables</Form.Label>
                  <Form.Control
                    type="text"
                    disabled
                    value={editAccountPayables} // ✅ NEW VARIABLE
                    onChange={(e) => setEditAccountPayables(e.target.value)}
                    style={{ fontSize: "13px", height: 32 }}
                  />
                </Col>
                <Col md={4}>
                  <Form.Label style={{ marginBottom: 2, padding: 0, fontWeight: 'bold' }}>Amount</Form.Label>
                  <CurrencyInput
                    id="edit-total-amount"
                    name="totalAmount"
                    value={editAmount} // ✅ NEW VARIABLE
                    decimalsLimit={2}
                    onValueChange={(value) => setEditAmount(value)} // ✅ NEW SETTER
                    groupSeparator=","
                    placeholder="Enter Amount"
                    style={{ fontSize: "13px", height: 32, textAlign: "right" }}
                    className={`form-control ${classes.optioncss}`}
                  />
                </Col>
              </>
            ) : (
              <>
                <Col md={4}>
                  <Form.Label style={{ marginBottom: 2, padding: 0, fontWeight: 'bold' }}>Account Payables</Form.Label>
                  <Select
                    options={bankOptions2}
                    value={editSelectedBank2} // ✅ NEW VARIABLE
                    onChange={setEditSelectedBank2} // ✅ NEW SETTER
                    placeholder="Select an Option"
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      control: (base, state) => ({ ...base, fontSize: "12px", minHeight: "32px", height: "32px", borderColor: state.isFocused ? "#2684ff" : base.borderColor, boxShadow: state.isFocused ? "0 0 0 1px #2684ff" : "none" }),
                    }}
                  />
                </Col>
                <Col md={4}>
                  <Form.Label style={{ marginBottom: 2, padding: 0, fontWeight: 'bold' }}>Amount</Form.Label>
                  <CurrencyInput
                    id="edit-total-amount"
                    name="totalAmount"
                    value={editAmount} // ✅ NEW VARIABLE
                    decimalsLimit={2}
                    onValueChange={(value) => setEditAmount(value)} // ✅ NEW SETTER
                    groupSeparator=","
                    placeholder="Enter Amount"
                    style={{ fontSize: "13px", height: 32, textAlign: "right" }}
                    className={`form-control ${classes.optioncss}`}
                  />
                </Col>
              </>
            )}

            {/* UPLOAD */}
            <Col md={4}>
              <Form.Label style={{ marginBottom: 2, padding: 0 }}>Upload Supporting Document (PDF)</Form.Label>

              {editExistingAttachment ? (
                // STATE 1: SHOW EXISTING FILE (Simulated Input)
                <div style={{ display: "flex", gap: "5px" }}>
                  <Form.Control
                    type="text"
                    value={editExistingAttachment.split('/').pop()} // Shows just the filename from the URL
                    disabled
                    style={{ fontSize: "13px", height: 32, backgroundColor: "#e9ecef" }}
                  />
                  <Button
                    variant="danger"
                    size="sm"
                    style={{ height: 32, display: "flex", alignItems: "center" }}
                    onClick={() => {
                      setEditExistingAttachment(null); // Removes the URL to show the upload input
                      setEditAttachment(null);
                    }}
                  >
                    ✕ {/* Clicking this removes the file and shows the upload input */}
                  </Button>
                </div>
              ) : (
                // STATE 2: UPLOAD INPUT (Shows when no existing file is present)
                <Form.Control
                  type="file"
                  accept="application/pdf"
                  onChange={(e) => setEditAttachment(e.target.files[0])}
                  style={{ fontSize: "13px", height: 32 }}
                  className={`form-control ${classes.optioncss}`}
                />
              )}
            </Col>
          </Row>

          <Modal.Title style={{ fontSize: 18, padding: "15px 20px 15px 0px" }}><b>Account Breakdown</b></Modal.Title>
          <div className={classes.mainTable} style={{ paddingBottom: 30 }}>
            <div className="table-responsive" style={{ maxHeight: '200px', overflowY: 'auto', }}>
              <table className="table display bg-white m-0 card-table">
                <thead style={{ whiteSpace: "nowrap", textAlign: "left", }}>
                  <tr style={{ padding: "2px 10px", margin: "2px 10px", fontSize: 13 }}>
                    <th style={{ position: 'sticky', top: 0, background: '#f5f7fb', zIndex: 2, width: "30%", padding: "7px 10px", margin: "7px 10px" }}>Account Name</th>
                    <th style={{ position: 'sticky', top: 0, background: '#f5f7fb', zIndex: 2, width: "30%", padding: "7px 10px", margin: "7px 10px" }}>Account Code</th>
                    <th style={{ position: 'sticky', top: 0, background: '#f5f7fb', zIndex: 2, textAlign: "right", width: "15%", padding: "7px 10px", margin: "7px 10px" }}>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style={{ padding: "5px 10px", margin: "2px 10px", fontSize: 13 }}>
                    <td style={{ padding: "5px 10px", margin: "2px 10px" }}>
                      {((editPayableType?.value == 2) || (editPayableType?.value == 3) || (editPayableType?.value == 4)) ? (
                        <Form.Control
                          type="text"
                          disabled
                          value={editAccountExpenses} // ✅ NEW VARIABLE
                          onChange={(e) => setEditAccountExpenses(e.target.value)}
                          style={{ fontSize: "13px", height: 32 }}
                        />
                      ) : (
                        <Select
                          options={bankOptions}
                          value={editSelectedBank} // ✅ NEW VARIABLE
                          placeholder="Select an Option"
                          onChange={(option) => {
                            // ✅ Custom Logic for Edit Mode
                            setEditSelectedBank(option);
                            if (option) {
                              setEditAccountCode(option?.gl_code || "");
                            } else {
                              setEditAccountCode("");
                            }
                          }}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            control: (base, state) => ({ ...base, fontSize: "12px", minHeight: "32px", height: "32px", borderColor: state.isFocused ? "#2684ff" : base.borderColor, boxShadow: state.isFocused ? "0 0 0 1px #2684ff" : "none" }),
                          }}
                        />
                      )}
                    </td>
                    <td style={{ padding: "5px 10px", margin: "2px 10px" }}>
                      <Form.Control
                        type="text"
                        value={editAccountCode} // ✅ NEW VARIABLE
                        disabled
                        onChange={(e) => setEditAccountCode(e.target.value)}
                        required
                        style={{ width: "100%", fontSize: "13px", height: 32 }}
                      />
                    </td>
                    <td style={{ textAlign: "right", padding: "5px 10px", margin: "2px 10px" }}>
                      <CurrencyInput
                        id="edit-total-amount-table"
                        name="totalAmount"
                        value={editAmount} // ✅ NEW VARIABLE
                        decimalsLimit={2}
                        disabled
                        onValueChange={(value) => setEditAmount(value)} // ✅ NEW SETTER
                        groupSeparator=","
                        placeholder="Enter Amount"
                        style={{ fontSize: "13px", height: 32, textAlign: "right" }}
                        className={`form-control ${classes.optioncss}`}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer style={{ padding: "40px 30px 10px 30px" }}>
          <Button variant="light" onClick={() => setShowUpdateModal(false)}>
            Go back
          </Button>
          <Button variant="success" onClick={updatePayment} disabled={updatePaymentLoading} className={classes.btnss}>
            {updatePaymentLoading ? ( // ✅ NEW LOADING STATE
              <>
                <Spinner size="sm" />
                <span style={{ marginLeft: "5px" }}>Processing...</span>
              </>
            ) : (
              "Update Changes"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal size='lg' show={showPaymentModal} onHide={() => setShowPaymentModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Payments - Bulk Entries</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group row">
            <label

            >
              Transaction Date:
            </label>
            <div >
              <input
                className="form-control"
                required
                type="date"
                onChange={handleDateChange}
                name="date"
                value={selectedDate}
                // min={minDate}
                // max={maxDate}
                style={{}}
              />
            </div>
          </div>

          <div style={{ marginTop: 10 }} />
          <label>
            Bank:
          </label>
          <Select
            options={selectOptions1}
            placeholder="Select Bank"
            onChange={handleBankChange}
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              menu: (provided) => ({
                ...provided,
                maxHeight: '300px',
                overflowY: 'auto',
              }),
            }}
          />
          <div style={{ marginTop: 10 }} />
          <label>
            Description:
          </label>
          <div>
            <input
              className="form-control"
              required
              name="description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              // rows={1} // adjust height
              style={{ resize: "vertical" }} // user can resize vertically if needed
            />
          </div>
          <div style={{ marginBottom: 10 }} />
          <table className={classes.invoiceTable}>
            <table className={classes.invoiceTable}>
              <thead>
                <tr>
                  <th>S/N</th>
                  <th>Beneficiary</th>
                  <th>Description</th>
                  <th>Total Amount</th>
                  <th>Amount Paid</th>
                  <th>Balance</th>
                  <th>Amount To Pay</th>
                </tr>
              </thead>
              <tbody>
                {selectedRows.map((row, index) => (
                  <tr key={row.id}>
                    <td>{index + 1}</td>
                    {/* <td>{row.transaction_date}</td> */}
                    <td>{row.supplier?.name || row.customer?.name}</td>
                    <td>{row.description}</td>
                    {/* <td>{row.invoice_number}</td> */}
                    <td style={{ textAlign: "right" }}>
                      {parseFloat(row.amount).toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}
                    </td>
                    <td style={{ textAlign: "right" }}>
                      {parseFloat(row.amount_paid).toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}
                    </td>
                    <td style={{ textAlign: "right" }}>
                      {parseFloat(row.balance).toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}
                    </td>
                    <td>
                      <input
                        type="number"
                        className="form-control"
                        style={{ fontSize: "12px" }}
                        value={row.amountToPay ?? row.balance}   // prefill with total amount
                        min="0"
                        max={row.balance}                       // restrict max to total amount
                        onChange={(e) => {
                          let newValue = parseFloat(e.target.value);

                          if (isNaN(newValue)) newValue = 0;
                          if (newValue > parseFloat(row.balance)) {
                            newValue = parseFloat(row.balance);
                          }
                          setSelectedRows((prev) =>
                            prev.map((r) =>
                              r.id === row.id ? { ...r, amountToPay: newValue } : r
                            )
                          );
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </table>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowPaymentModal(false)}>
            Cancel
          </Button>
          <Button style={{ whiteSpace: "nowrap" }} className={classes.btnss} disabled={selectedRows.length === 0 || !selectedBank || !selectedDate || !description} onClick={handleConfirmPaymentInstruction}>
            Generate Instruction
          </Button>
          <Button style={{ whiteSpace: "nowrap" }} className={classes.btnss} disabled={selectedRows.length !== 1 || !selectedBank || !selectedDate || !description} onClick={handleNavCheque}>
            Print Cheque
          </Button>
        </Modal.Footer>
      </Modal>
      {/* <PayableEntryModal
                      isOpen={show2}
                      onClose={() => setShow2(false)}
                  /> */}

      {/* <Footer /> */}
      {/* Add New Supplier Modal */}

<Modal show={showSupplierModal} onHide={handleSupplierModalClose} size="lg" animation={false}>
  <Modal.Header closeButton>
    <Modal.Title>Add New Supplier/Contractor</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <Form.Group className="mb-3">
        <Row>
          <Col>
            <Form.Label style={{ marginTop: 20, fontSize: "12px" }}>Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Name"
              value={supplierFullName}
              onChange={(e) => setSupplierFullName(e.target.value)}
            />
          </Col>

          <Col>
            <Form.Label style={{ marginTop: 20, fontSize: "12px" }}>Email</Form.Label>
            <Form.Control
              type="text"
              placeholder="Email"
              value={supplierEmail}
              onChange={(e) => setSupplierEmail(e.target.value)}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <Form.Label style={{ marginTop: 20, fontSize: "12px" }}>Phone Number</Form.Label>
            <Form.Control
              type="text"
              placeholder="Phone Number"
              value={supplierPhone}
              onChange={(e) => setSupplierPhone(e.target.value)}
            />
          </Col>

          <Col>
            <Form.Label style={{ marginTop: 20, fontSize: "12px" }}>Address</Form.Label>
            <Form.Control
              type="text"
              placeholder="Address"
              value={supplierAddress}
              onChange={(e) => setSupplierAddress(e.target.value)}
            />
          </Col>
        </Row>
      </Form.Group>

      <Form.Group>
        <Container fluid style={{ marginTop: "40px" }} className={classesStyles.wrapper}>
          <h6 className={classesStyles.headerText} style={{ textAlign: "left" }}>Add Bank Accounts</h6>

          <div className="table-responsive">
            <table className={classesStyles.customtable}>
              <thead>
                <tr>
                  <th>Bank Name</th>
                  <th>Account Name</th>
                  <th>Account Number</th>
                  <th style={{ backgroundColor: "unset" }} className="text-center">
                    <button type="button" style={{ backgroundColor: "unset" }} className={classesStyles.plusbtn} onClick={addRow}>
                      <FaPlus size={12} color="white" style={{ cursor: "pointer" }} />
                    </button>
                  </th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => (
                  <tr key={index}>
                    <td>
                      <Form.Control
                        type="text"
                        value={row.bankName}
                        onChange={(e) => handleChange(index, "bankName", e.target.value)}
                      />
                    </td>
                    <td>
                      <Form.Control
                        type="text"
                        value={row.accName}
                        onChange={(e) => handleChange(index, "accName", e.target.value)}
                      />
                    </td>
                    <td>
                      <Form.Control
                        type="text"
                        value={row.accNo}
                        onChange={(e) => handleChange(index, "accNo", e.target.value)}
                      />
                    </td>
                    <td className="text-center">
                      <button type="button" style={{ backgroundColor: "unset" }} className={classesStyles.btntrash} onClick={() => deleteRow(index)}>
                        <FaTrash size={12} color="red" style={{ cursor: "pointer" }} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Container>
      </Form.Group>
    </Form>
  </Modal.Body>
  <Modal.Footer style={{ marginRight: "14px" }}>
    <Button variant="danger" onClick={handleSupplierModalClose}>
      Go back
    </Button>
    <Button className={classesStyles.customButton} onClick={createBeneficiary} disabled={supplierLoading}>
      {supplierLoading ? (
        <>
          <Spinner size="sm" />
          <span style={{ marginLeft: "5px" }}>Creating...</span>
        </>
      ) : (
        "Create Supplier"
      )}
    </Button>
  </Modal.Footer>
</Modal>
    </div>
  );
};

export default PayablesEntries;
